<template>
  <div class="page" id="feature" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
    <div class="feature-body">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="feature-left" v-bind:class="{ 'small-desktop': $parent.smallDeskTop, 'mini-desktop': $parent.miniDeskTop }">
            <span class="mockup-box" v-if="showMockup" ref="mockupBox"><img class="mockup" src="../assets/w_mockup_frame_6.png" alt="w-mockup" @load="readyToShowMockup"/></span>
            <div class="video-box" v-if="showVideo" ref="videoBox" v-bind:style="{ 'width': (mockupBoxWidth - 32)+ 'px', 'height': '100%'} ">
              <video @canplay="updatePaused" autoplay muted ref="videoTarget" v-bind:class="{ show : showMockup && isVideoReady }" playsinline v-bind:style="{ 'width': (mockupBoxWidth - 16) + 'px', height: 'auto' } ">
                <source src="../assets/df_motion.mp4" type="video/mp4" >
              </video>
            </div>
            <img src="../assets/loader.gif" class="loader" v-if="showMockup && !isVideoReady" alt="loader"/>
          </v-col>

          <transition name="showDesc">
          <v-col cols="12" sm="6" class="feature-right" v-if="showDesc">
            <span class="brand-box"><img src="../assets/logo_ko_w.svg" alt="logo-ko" /></span>
            <p class="feature-desc">
              이렇게 먹어도 될까? 어떻게 먹어야 할까<br/>챙길 것도, 알아야 할 것도 너무 많은 다이어트!
              <br/>
              똑똑한 친구 '람희'가 모두 알려주니까 <br/> 더 이상 <strong>다이어트 걱정은 노놉</strong>!!
            </p>
            <transition name="showCtaBtns">
              <ul class="cta-btns test" v-if="showCtaBtns">
                <li class="cta-btn"><a class="cta-go" href="#" @click="playDf"><font-awesome-icon :icon="['fas', 'play']"></font-awesome-icon></a></li>
                <li class="cta-btn"><a class="cta-go" href="#" @click="pauseDf"><font-awesome-icon :icon="['fas', 'pause']"></font-awesome-icon></a></li>
                <li class="cta-btn"><a class="cta-go" href="#" @click="replayDf"><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></a></li>
              </ul>
            </transition>
          </v-col>
          </transition>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Feature",
        props: ['isFeaturePageScrolled'],
        data: function () {
            return {
                videoElement: null,
                paused: null,
                showMockup: false,
                showCtaBtns: false,
                showDesc: false,
                showVideo: false,
                isVideoReady: false,
                mockupBoxWidth: 0,
                videoBoxHeight: 0,
                videoBoxWidth: 0,
            }
        },
        watch: {
            isFeaturePageScrolled: function (isCurrent) {
              if(isCurrent) {
                  this.showDesc = true;
                  this.showMockup = true;
                  this.isVideoReady ? this.startPlay() : console.log('not yet loaded');
              }
            },
            isVideoReady: function (newVal) {
                newVal ? this.startPlay() : false;
            }
        },
        methods: {
            updatePaused (e) {
                this.videoElement = e.target;
                if(this.$refs.mockupBox.clientWidth) {
                    this.mockupBoxWidth = this.$refs.mockupBox.clientWidth;
                }
                this.videoElement.muted = true;
                this.isVideoReady = true;
            },
            playDf() {
                this.videoElement.play();
            },
            pauseDf() {
                this.videoElement.pause();
            },
            replayDf() {
                this.videoElement.load();
                this.videoElement.play();
            },
            startPlay() {
                if(this.isVideoReady) {
                  this.videoElement.play();
                  this.showCtaBtns = true;
                }
            },
            async readyToShowMockup() {
                this.showVideo = true;
            }
        },
    }
</script>

<style scoped lang="scss">
@import '../variables';
#feature.show-mobile {
  overflow: visible !important;
  height: auto !important;
  padding: 2rem 0;
  .feature-body {
    position: relative;
    height: auto;
    .container {
      height: auto;
    }
    .row {
      height: auto !important;
      margin: 0;
    }
  }
  .feature-left {
    order: 2;
    .mockup-box {
      width: 300px !important;
      height: auto !important;
      .mockup {
        width: 300px !important;
        height: auto !important;
      }
    }
    .video-box {
      video {
      }
    }
    .loader {

    }
  }
  .feature-right {
    order: 1;
    padding-left: 2rem;
    .brand-box {
      img {
        height: 30px !important;
      }
    }
    .feature-desc {
      font-size: 1.2em !important;
      padding-bottom: 1rem !important;
    }
  }
}
#feature {
  background: rgba(140,199,254,1);
  background: -moz-linear-gradient(top, rgba(140,199,254,1) 0%, rgba(140,199,254,1) 14%, rgba(95,175,250,1) 100%);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(140,199,254,1)), color-stop(14%, rgba(140,199,254,1)), color-stop(100%, rgba(95,175,250,1)));
  background: -webkit-linear-gradient(top, rgba(140,199,254,1) 0%, rgba(140,199,254,1) 14%, rgba(95,175,250,1) 100%);
  background: -o-linear-gradient(top, rgba(140,199,254,1) 0%, rgba(140,199,254,1) 14%, rgba(95,175,250,1) 100%);
  background: -ms-linear-gradient(top, rgba(140,199,254,1) 0%, rgba(140,199,254,1) 14%, rgba(95,175,250,1) 100%);
  background: linear-gradient(to bottom, rgba(140,199,254,1) 0%, rgba(140,199,254,1) 14%, rgba(95,175,250,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8cc7fe', endColorstr='#5faffa', GradientType=0 );


  /*animate object*/
  .showMockup-enter-active {
    animation: bounce-in-top 0.8s;
  }
  .showMockup-leave-active {
    animation: bounce-in-top 0.8s reverse;
  }

  .showDesc-enter-active {
    animation: fade-in-top 0.8s;
  }
  .showDesc-leave-active {
    animation: fade-in-top 0.8s reverse;
  }

  .showCtaBtns-enter-active {
    animation: slide-in-right 0.4s;
  }
  .showCtaBtns-leave-active {
    animation: slide-in-right 0.4s reverse;
  }

  .feature-body {
    height: 100%;
    .container {
      height: 100%;

      .row {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
      }
      .feature-left {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3rem 0;
        height: 100%;

        .mockup-box {
          position: relative;
          min-height: 434px;
          min-width: 200px;
          max-width: 400px;
          max-height: 868px;
          width: auto;
          height: 100%;
          overflow: hidden;
          float: left;
          z-index: 99;

          img {
            width: auto;
            height: 100%;
            min-height: 434px;
            min-width: 200px;
            max-width: 400px;
            max-height: 868px;
            z-index: 99;
          }
        }
        .loader {
          z-index: 999;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          margin: auto;
        }
        .video-box {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          min-height: 434px;
          min-width: 160px;
          max-width: 351px;
          max-height: 868px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 90;

          video {
            position: relative;
            z-index: 90;
            display: none;
            margin-top: -6px;
          }
          video.show {
            display: block;
          }
        }
      }
      .feature-left.small-desktop {
        padding: 2rem 0 !important;
        .video-box {
          align-items: center !important;
        }
      }
      .feature-left.mini-desktop {
        padding: 1rem 0 !important;
        .video-box {
          align-items: center !important;
        }
      }
      .feature-right {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;

        .brand-box {
          font-size: 4em;
          color: white;
          font-family: $brandFont;
          img {
            height: 50px;
            width: auto;
          }
        }
        .feature-desc {
          font-size: 1.4em;
          line-height: 2em;
          color: white;
          font-family: $basicFont;
          padding-bottom: 4rem;
          strong {
            color: $softPinkColor;
            font-size: 1.2em;
            text-underline-position: under;
          }
        }
        .cta-btns {
          position: relative;
          margin-left: -8px;
          padding: 0;

          .cta-btn {
            position: relative;
            display: inline-block;
            margin-right: 1rem;
            text-align: center;
            .cta-go {
              display: inline-block;
              padding: 0.5rem 1rem;
              margin: 0.5rem 0;
              text-decoration: none;
              font-size: 2em;
              color: $basicFontColor;
            }
            .cta-go:hover {
              color: $greyFontColor;
              transition: ease-in-out 0.1s;
            }
          }
        }
      }
    }
  }
}
</style>
